import React, { useEffect, useState } from "react";
import MicIcon from "@material-ui/icons/Mic";
import StopIcon from "@material-ui/icons/Stop";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import { Fade } from "@mui/material";
import PauseIcon from "@material-ui/icons/Pause";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

const useStyles = makeStyles(() => ({
    stopButton: {
        position: "relative",
        backgroundColor: "#8f3934",
        color: "white",
        opacity: 1,
        zIndex: 3,
        transition: "all 0.2s",
        display: "flex",
        justifyContent: "center",
        "&:hover": {
            backgroundColor: "#8f3934",
            opacity: 0.9,
        },
    },
    startButton: {
        position: "relative",
        backgroundColor: "#272727",
        color: "white",
        opacity: 1,
        zIndex: 3,
        transition: "all 0.2s",
        display: "flex",
        justifyContent: "center",
        "&:hover": {
            backgroundColor: "#272727",
            opacity: 0.9,
        },
    },
}));

const RecordView = (props: any) => {
    const [second, setSecond] = useState("00");
    const [minute, setMinute] = useState("00");
    const [isActive, setIsActive] = useState(false);
    const [counter, setCounter] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        let intervalId: any;

        if (isActive && !isPaused && props.permissao) {
            intervalId = setInterval(() => {
                const secondCounter = counter % 60;
                const minuteCounter = Math.floor(counter / 60);

                let computedSecond: any =
                    String(secondCounter).length === 1
                        ? `0${secondCounter}`
                        : secondCounter;
                let computedMinute: any =
                    String(minuteCounter).length === 1
                        ? `0${minuteCounter}`
                        : minuteCounter;

                setSecond(computedSecond);
                setMinute(computedMinute);

                setCounter((counter) => counter + 1);
            }, 1000);
        }

        return () => clearInterval(intervalId);
    }, [isActive, counter, isPaused, props.permissao]);

    function stopTimer() {
        setIsActive(false);
        setCounter(0);
        setSecond("00");
        setMinute("00");
    }

    return (
        <>
            <Box sx={{ width: "100%", display: "flex" }}>
                {!isActive ? (
                    <Box sx={{ display: "flex" }}>
                        <Tooltip
                            title="Começar gravação"
                            aria-label="record"
                            placement="right"
                        >
                            <Fab
                                className={classes.startButton}
                                onClick={() => {
                                    setIsActive(!isActive);
                                    props.startRecord();
                                }}
                                aria-label="record"
                                size="small"
                                color="secondary"
                            >
                                <MicIcon />
                            </Fab>
                        </Tooltip>
                    </Box>
                ) : (
                    <Fade in={isActive}>
                        <Box
                            sx={{
                                width: 150,
                                height: 40,
                                border: "1px solid #ebebeb",
                                borderRadius: "12px",
                                backgroundColor: "#ebebeb",
                                zIndex: 30,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                            }}
                        >
                            <Box sx={{ display: "flex" }}>
                                <span style={{ fontSize: "16px" }}>
                                    {minute}
                                </span>
                                <span style={{ fontSize: "16px" }}>:</span>
                                <span style={{ fontSize: "16px" }}>
                                    {second}
                                </span>
                            </Box>
                            <Box sx={{ display: "flex" }}>
                                {!isPaused ? (
                                    <Box
                                        onClick={() => {
                                            setIsPaused(!isPaused);
                                            props.pauseRecord();
                                        }}
                                    >
                                        <PauseIcon
                                            style={{ fontSize: "32px" }}
                                        />
                                    </Box>
                                ) : (
                                    <Box
                                        onClick={() => {
                                            setIsPaused(!isPaused);
                                            props.resumeRecord();
                                        }}
                                    >
                                        <PlayArrowIcon
                                            style={{ fontSize: "32px" }}
                                        />
                                    </Box>
                                )}
                                <Box
                                    onClick={() => {
                                        stopTimer();
                                        props.stopRecord();
                                    }}
                                >
                                    <StopIcon style={{ fontSize: "32px" }} />
                                </Box>
                            </Box>
                        </Box>
                    </Fade>
                )}
            </Box>
        </>
    );
};
export default RecordView;
